/* eslint-disable react-hooks/exhaustive-deps */
import {
  Box,
  Typography,
  // Divider,
  Button,
  // Popover,
  TextField,
  InputAdornment,
  Menu,
  MenuItem,
} from "@mui/material";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
// import LoadingSpinner from "../../components/Composables/CircularProgressBar";
import DynamicDataGrid from "../../components/Composables/DynamicDataGrid";
// import DynamicForm from "../../components/Composables/DynamicForm";
// import AddToJob from "../../components/Composables/AddToJob";
// import CustomSnackbar from "../../components/Composables/CustomSnackBarMenu";
import ChevronLeftOutlinedIcon from "@mui/icons-material/ChevronLeftOutlined";
// import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
// import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import SearchIcon from "@mui/icons-material/Search";
import FilterListIcon from "@mui/icons-material/FilterList";

function AddedCandidates({ processedFiles, isProcessing }) {
  const [hoverBackButton, setHoverBackButton] = useState(false);

  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);

  useEffect(() => {
    const storedJobId = localStorage.getItem("bulkUploadJobId");
    if (!storedJobId) {
      navigate("/candidates", { replace: true });
    }
  }, [navigate]);

  const rows = processedFiles.map((file, index) => ({
    id: index + 1,
    sno: index + 1,
    candidateId: file.id,
    ...file,
  }));

  const filteredRows = rows.filter((row) => {
    const matchesSearch = row.fileName
      .toLowerCase()
      .includes(search.toLowerCase());
    const matchesStatus =
      statusFilter === "all" || row.status?.toLowerCase() === statusFilter;
    return matchesSearch && matchesStatus;
  });

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        padding: "16px",
        backgroundColor: "#E3F2FD",
        height: "100%",
        boxSizing: "border-box",
        borderRadius: "24px 0 0 0",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          borderRadius: "12px",
          padding: "16px",
          backgroundColor: "white",
          flex: 1,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            flexShrink: 0,
            mb: 2,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <Button
              startIcon={
                <ChevronLeftOutlinedIcon
                  style={{ height: "16px", width: "16px" }}
                />
              }
              onMouseEnter={() => setHoverBackButton(true)}
              onMouseLeave={() => setHoverBackButton(false)}
              sx={{
                "& .MuiButton-startIcon": hoverBackButton
                  ? { marginRight: "4px !important" }
                  : {
                      margin: "0px",
                    },
                padding: "4px",
                backgroundColor: hoverBackButton ? "#3F95EA" : "#E7E7E7",
                color: hoverBackButton ? "white" : "#1A1A1A",
                height: "24px",
                fontSize: 12,
                textTransform: "none",
                minWidth: hoverBackButton ? "12" : 24,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                "&:hover": {
                  backgroundColor: hoverBackButton ? "#3F95EA" : "#E7E7E7",
                },
              }}
              onClick={() => navigate(-1)}
            >
              {hoverBackButton ? "Back" : ""}
            </Button>
            <Typography sx={{ fontSize: "22px", fontWeight: 600 }}>
              List of Candidates
            </Typography>
          </Box>
          <Box sx={{ display: "flex", gap: 1.5 }}>
            <TextField
              size="small"
              placeholder="Search"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
            <Box>
              <Button
                variant="contained"
                startIcon={<FilterListIcon />}
                onClick={handleMenuOpen}
                disabled={isProcessing}
              >
                Filter
              </Button>
              <Menu anchorEl={anchorEl} open={open} onClose={handleMenuClose}>
                <MenuItem
                  disabled={statusFilter === "all"}
                  onClick={() => {
                    setStatusFilter("all");
                    handleMenuClose();
                  }}
                >
                  All
                </MenuItem>
                <MenuItem
                  disabled={statusFilter === "successful"}
                  onClick={() => {
                    setStatusFilter("successful");
                    handleMenuClose();
                  }}
                >
                  Successful
                </MenuItem>
                <MenuItem
                  disabled={statusFilter === "failed"}
                  onClick={() => {
                    setStatusFilter("failed");
                    handleMenuClose();
                  }}
                >
                  Failed
                </MenuItem>
              </Menu>
            </Box>
            {/* <Button
              size="small"
              variant="contained"
              onClick={() => navigate("/blogs/create")}
            >
              <AddIcon sx={{ marginRight: 1 }} />
              Create New Blog
            </Button> */}
          </Box>
        </Box>

        <Box sx={{ flex: 1, overflow: "hidden" }}>
          <DynamicDataGrid
            rows={filteredRows}
            hideFooter
            onRowClick={(params) => {
              if (params.row.candidateId) {
                navigate(`/candidates/${params.row.candidateId}`);
              }
            }}
            // getRowClassName={(params) =>
            //   params.row.candidateId ? "clickable-row" : "non-clickable-row"
            // }
          />
        </Box>
      </Box>
    </Box>
  );
}
export default AddedCandidates;
